module.exports = __webpack_public_path__ + "fonts/NunitoSans-Black.b6a9ed3.ttf";